import React, { Fragment } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter} from "react-router-dom";
//import reportWebVitals from './reportWebVitals';

import './index.css';
import App from './App';
import { initializeI18n } from './i18n';

initializeI18n();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    {(process.env.PUBLIC_URL === "/test")? "TEST ENVIRONMENT" : ""}
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <App/>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
